__webpack_require__.p = "/Sonic-Battle-Universe/";